import { useContext } from 'react';
import type { NotesContextValue } from '../../types';
import { NotesContext } from '../context/NotesContext';

export function useNotesContext(): NotesContextValue {
    const ctx = useContext(NotesContext);
    if (!ctx) throw new Error('useNotesContext must be used within NotesProvider');
    return ctx;
}
